import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-bg" }
const _hoisted_2 = { class: "opebtn" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 新增 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 编辑 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_search_list = _resolveComponent("c-search-list")
  const _component_el_button = _resolveComponent("el-button")
  const _component_c_table = _resolveComponent("c-table")
  const _component_edit_dialog = _resolveComponent("edit-dialog")
  const _directive_hasAuth = _resolveDirective("hasAuth")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_c_search_list, {
      inputList: _ctx.inputList,
      onOnSearch: _ctx.handleSearch,
      onOnReset: _ctx.handleReset
    }, null, 8, ["inputList", "onOnSearch", "onOnReset"]),
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addOrUpdateHandle())),
        icon: "el-icon-plus"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 512), [
        [_directive_hasAuth, 'system-notice-add']
      ])
    ]),
    _createVNode(_component_c_table, {
      dataSource: _ctx.tableConfig,
      isIndex: true,
      onPageCurrentChange: _ctx.pageCurrentChange,
      onPageSizeChange: _ctx.pageSizeChange
    }, {
      action: _withCtx((scope) => [
        _withDirectives(_createVNode(_component_el_button, {
          type: "text",
          size: "small",
          onClick: ($event: any) => (_ctx.addOrUpdateHandle(scope.row))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 2
        }, 1032, ["onClick"]), [
          [_directive_hasAuth, 'system-notice-edit']
        ])
      ]),
      _: 1
    }, 8, ["dataSource", "onPageCurrentChange", "onPageSizeChange"]),
    (_ctx.editVisible)
      ? (_openBlock(), _createBlock(_component_edit_dialog, {
          key: 0,
          visible: _ctx.editVisible,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editVisible = $event)),
          "row-data": _ctx.rowData,
          onSuccess: _ctx.getList
        }, null, 8, ["visible", "row-data", "onSuccess"]))
      : _createCommentVNode("", true)
  ]))
}